import {
  buildShareRecipientConversationSpec,
  ensureDirectConversation,
  findShareTokenForDirectChat,
  sendDirectMessage,
} from './directChatService';

/**
 * Send the same text to each recipient's share_recipient DM with the deal owner (creates thread if needed).
 * @param {{
 *   ownerUid: string,
 *   ownerDisplayName: string,
 *   text: string,
 *   recipients: Array<{ uid: string, shareTokens?: string[], revoked?: boolean }>,
 *   propertyShareTokens: string[],
 * }} args
 * @returns {Promise<{ sent: number, failed: number }>}
 */
export async function broadcastOwnerMessageToShareRecipients({
  ownerUid,
  ownerDisplayName,
  text,
  recipients,
  propertyShareTokens,
}) {
  const trimmed = (text || '').trim();
  const ou = String(ownerUid || '');
  if (!ou || !trimmed) return { sent: 0, failed: 0 };

  const name = (ownerDisplayName || '').trim().slice(0, 120);
  const fallbacks = (propertyShareTokens || []).filter(Boolean);
  let sent = 0;
  let failed = 0;

  for (const row of recipients || []) {
    const uid = row?.uid;
    if (!uid || uid === ou || row.revoked) continue;
    const rowToks = Array.isArray(row.shareTokens) ? row.shareTokens.filter(Boolean) : [];
    const candidates = [...rowToks, ...fallbacks];
    try {
      const tok = await findShareTokenForDirectChat(ou, uid, candidates);
      if (!tok) {
        failed += 1;
        continue;
      }
      const spec = buildShareRecipientConversationSpec(tok, ou, uid);
      await ensureDirectConversation(spec.conversationId, {
        participantUids: spec.participantUids,
        kind: spec.kind,
        context: spec.context,
      });
      await sendDirectMessage(spec.conversationId, ou, name, trimmed);
      sent += 1;
    } catch (e) {
      console.warn('broadcastOwnerMessageToShareRecipients', uid, e);
      failed += 1;
    }
  }

  return { sent, failed };
}
